import type {ReactElement, RefObject} from 'react';
import React, {useEffect} from 'react';

import CSSModules from 'react-css-modules';

import Button from '../../../../Button';
import Text from '../../../../TextComponents/Text';

import styles from './styles.module.scss';

type Props = {
  containerRef?: RefObject<HTMLDivElement>;
  contentRef?: RefObject<HTMLDivElement>;
  isLightTheme: boolean;
  text: string;
  icon?: ReactElement;
};

const PreviewProgressButton = ({
  containerRef,
  contentRef,
  isLightTheme,
  text,
  icon,
}: Props): JSX.Element => {
  const [width, setWidth] = React.useState(0);
  // Need to use an effect here in order to 'live update' the width as user is typing
  useEffect(() => {
    if (contentRef?.current) {
      setWidth(contentRef.current.scrollWidth);
    }
  }, [contentRef?.current?.scrollWidth, contentRef]);

  const isArrowVisible = width ? width < 124 : true;

  return (
    <div ref={containerRef} styleName='button'>
      <Button
        noMarginTop
        noMarginLeft
        disabled={false}
        isLightTheme={isLightTheme}
        type='progress'
        dataAutomation='preview-nav-button'
      >
        <Text inline size='m' weight='medium' maxLines={2}>
          <div ref={contentRef}>{text}</div>
        </Text>
        {isArrowVisible ? icon : null}
      </Button>
    </div>
  );
};

export default CSSModules(PreviewProgressButton, styles);
